import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Shelf } from 'bookraw/shared/models/shelf.model';
import { environment } from 'env/environment';

@Injectable()
export class ShelvesService extends ListService<Shelf> {

  url: string = '/api/admin/shelfs';

  saveLibraryOrder(libraryId: number, order: number[]) {
    return this.http.post(
      environment.baseURL + '/api/admin/shelves/libraryOrder/' + libraryId,
      { shelfIds: order }
    );
  }
}
